<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><a id="page_3"><span class="line">   Contents   </span></a></p><a id="page_3">
<div class="fig">
<p class="fig-img"><img alt="" class="image" src="images/ufig_3.jpg"/></p>
</div>
</a><p class="toc1"><a id="page_3"></a><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></p>
<p class="toc2"><a href="#/xhtml/06_The_Pleasures_of_Tea">The Pleasures of Tea</a></p>
<p class="toc2"><a href="#/xhtml/07_Growing_Tea">Growing Tea</a></p>
<p class="toc2"><a href="#/xhtml/08_The_History_of_Tea">The History of Tea</a></p>
<p class="toc2"><span href="#/xhtml/09_Styles_and_Customs_Today" title="Link target outside of Sample">Styles and Customs Today</span></p>
<p class="toc2"><span href="#/xhtml/10_Choosing_and_Using_Tea" title="Link target outside of Sample">Choosing and Using Tea</span></p>
<p class="toc2"><span href="#/xhtml/11_A_Perfect_Cup_of_Tea" title="Link target outside of Sample">A Perfect Cup of Tea</span></p>
<p class="toc1a"><span class="color1" href="#/xhtml/13_Chapter01_Head" title="Link target outside of Sample">Tea Served Hot, Cold and Frozen</span></p>
<p class="toc2"><span href="#/xhtml/14_Chapter01#sec1" title="Link target outside of Sample">Hot drinks with alcohol</span></p>
<p class="toc2"><span href="#/xhtml/14_Chapter01#sec2" title="Link target outside of Sample">Cold drinks with alcohol</span></p>
<p class="toc2"><span href="#/xhtml/14_Chapter01#sec3" title="Link target outside of Sample">Hot non-alcoholic drinks</span></p>
<p class="toc2"><span href="#/xhtml/14_Chapter01#sec4" title="Link target outside of Sample">Cold non-alcoholic drinks</span></p>
<p class="toc2"><span href="#/xhtml/14_Chapter01#sec5" title="Link target outside of Sample">Frozen desserts</span></p>
<p class="toc1a"><span class="color1" href="#/xhtml/16_Chapter02_Head" title="Link target outside of Sample">Teatime</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec1" title="Link target outside of Sample">Good baking</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec2" title="Link target outside of Sample">Freezing teatime food</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec3" title="Link target outside of Sample">Modern yeast cookery</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec4" title="Link target outside of Sample">To follow the recipes</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec5" title="Link target outside of Sample">Teatime for slimmers</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec6" title="Link target outside of Sample">Regency teatime</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec7" title="Link target outside of Sample">Victorian teatime</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec8" title="Link target outside of Sample">Teatime in England</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec9" title="Link target outside of Sample">Teatime in Scotland</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec10" title="Link target outside of Sample">Teatime in Wales</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec11" title="Link target outside of Sample">Teatime in Ireland</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter02#sec12" title="Link target outside of Sample">Nursery Teas</span></p>
<p class="toc1a"><span class="color1" href="#/xhtml/19_Chapter03_Head" title="Link target outside of Sample">Teatime around the World</span></p>
<p class="toc2"><span href="#/xhtml/20_Chapter03#sec1" title="Link target outside of Sample">Australia</span></p>
<p class="toc2"><span href="#/xhtml/20_Chapter03#sec2" title="Link target outside of Sample">Canada</span></p>
<p class="toc2"><span href="#/xhtml/20_Chapter03#sec3" title="Link target outside of Sample">New Zealand</span></p>
<p class="toc2"><span href="#/xhtml/20_Chapter03#sec4" title="Link target outside of Sample">South Africa</span></p>
<p class="toc2"><span href="#/xhtml/20_Chapter03#sec5" title="Link target outside of Sample">USA</span></p>
<p class="toc1a"><span class="color1" href="#/xhtml/22_Chapter04_Head" title="Link target outside of Sample">High Tea</span></p>
<p class="toc1b"><span href="#/xhtml/24_Index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?467163a9